// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#branch .v-breadcrumbs__item .v-input {\n  padding-top: 30px;\n}\n#branch .v-breadcrumbs__item .v-input .v-input__slot {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n#branch-selector {\n  width: 25px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
